import React, { useState } from 'react'
import PropTypes from 'prop-types'
import truncate from 'lodash/truncate'
import { cx } from '@emotion/css'

import { ToggleButton } from './ToggleButton'
import MarkdownRenderer from '../MarkdownRenderer'

import styles from './styles'

const MarkdownReadMore = ({
  source: content = '',
  theme = 'primary',
  truncationLength = 200,
  truncationSeparator = ' ',
  className,
  ...props
}) => {
  const [open, setOpen] = useState(false)
  const contentLength = (content || '').length
  const contentPreview = truncate(content, {
    length: truncationLength,
    separator: truncationSeparator,
  })

  return (
    <>
      <MarkdownRenderer className={cx(styles.content, className)} theme={theme} source={open ? content : contentPreview} />
      {open ? (
        <ToggleButton label="Read less" theme={theme} setOpen={() => setOpen(false)} styles={styles} onCallback={props.onReadLess} />
      ) : null}
      {!open && contentLength > truncationLength ? (
        <ToggleButton label="Read more" theme={theme} setOpen={() => setOpen(true)} styles={styles} onCallback={props.onReadMore} />
      ) : null}
    </>
  )
}

MarkdownReadMore.propTypes = {
  source: PropTypes.string.isRequired,
  truncationLength: PropTypes.number,
  truncationSeparator: PropTypes.string,
  onReadMore: PropTypes.func,
  onReadLess: PropTypes.func,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'dark', 'tertiary', 'info']),
  className: PropTypes.string,
}

export default MarkdownReadMore
